import { Injectable } from '@angular/core';
import { PermissionsModuleAccessLevel } from '@predictiveindex/client-permissions-lib';
import { ModuleName } from '../core-data-model/ModuleAccess';
import { InitDataService } from './InitData';

@Injectable({ providedIn: 'root' })
export class ModuleUserAccessService {
    constructor(public initDataService: InitDataService) {}

    hasModuleAccessLevelOrAbove(
        module: string,
        accessLevel: PermissionsModuleAccessLevel
    ): boolean {
        if (this.initDataService.isSuperAdmin()) {
            return true;
        }
        return (
            this.initDataService.userAccessLevelMap.get(module)
                ?.userAccessLevel >= accessLevel
        );
    }

    hasAccessLevelForAnyModule(
        accessLevel: PermissionsModuleAccessLevel
    ): boolean {
        if (this.initDataService.isSuperAdmin()) {
            return true;
        }
        const moduleObjects = Array.from(
            this.initDataService.userAccessLevelMap.values()
        );
        return !!moduleObjects.find((m) => m.userAccessLevel >= accessLevel);
    }

    getUserAccessLevel(module: string): PermissionsModuleAccessLevel {
        const moduleMap = this.initDataService.userAccessLevelMap.get(module);
        if (moduleMap) {
            return moduleMap.userAccessLevel;
        }
        return PermissionsModuleAccessLevel.Unknown;
    }

    getAllowVMAccess(module: string): boolean {
        return this.initDataService.userAccessLevelMap.get(module)
            ?.allowVMAccess;
    }

    hasBasicHirePermissions() {
        return this.hasModuleAccessLevelOrAbove(
            ModuleName.Hire,
            PermissionsModuleAccessLevel.LimitedAccess
        );
    }

    hasBasicDesignPermissions() {
        return this.hasModuleAccessLevelOrAbove(
            ModuleName.Design,
            PermissionsModuleAccessLevel.LimitedAccess
        );
    }

    hasBasicDiagnosePermissions() {
        return this.hasModuleAccessLevelOrAbove(
            ModuleName.Diagnose,
            PermissionsModuleAccessLevel.LimitedAccess
        );
    }

    hasBasicPerformPermissions() {
        return this.hasModuleAccessLevelOrAbove(
            ModuleName.Perform,
            PermissionsModuleAccessLevel.LimitedAccess
        );
    }
}
